module.exports = __webpack_public_path__ + "media/img/Landing_Page/answer-profiling-with-ipad-bbc82a528c965f0c464fd0adf6585acf.png";